import { comDestino } from './destino';

/**
 * A espera pela confirmação do e-mail, com endereço próprio.
 *
 * **Era estado de componente, e por isso evaporava.** O `CriarContaPage`
 * guardava o e-mail num `useState` e trocava o formulário por um `Result`; em
 * 17/09/2026, medindo com um `MutationObserver`, esse `Result` viveu **5
 * milissegundos**: o `signUp` dispara a revalidação da sessão, o
 * `RedirectIfAuthenticated` troca o `<Outlet/>` por um `<Spin/>` enquanto ela
 * corre, a tela desmonta e o que remonta 58 ms depois é um formulário vazio. O
 * aluno criava a conta e não recebia instrução nenhuma.
 *
 * Rota resolve isso de raiz (D-1): sobrevive a remontagem, à recarga da página
 * e ao botão de voltar, e passa a ser um lugar para onde se pode **mandar**
 * alguém - o login faz isso quando recusa quem ainda não confirmou.
 */
export const CAMINHO_DA_VERIFICACAO = '/verifique-o-email';

/**
 * O e-mail pedido no endereço, ou nada.
 *
 * Sem e-mail não há reenvio possível, e a tela não tem o que dizer - quem chega
 * assim volta para o login. A conferência é a mínima que distingue endereço de
 * lixo: não é validação de e-mail, é recusa de texto que não serve para nada.
 */
export function emailDaVerificacao(bruto: string | null): string | null {
  if (!bruto) return null;
  const limpo = bruto.trim();
  if (limpo.length < 3 || !limpo.includes('@')) return null;
  return limpo;
}

/**
 * O endereço da espera, carregando o e-mail e o destino.
 *
 * O destino continua viajando (a intenção de comprar tem de sobreviver ao
 * cadastro), e é o `comDestino` que decide quando ele merece ir - assim a URL
 * de quem só quer estudar não ganha parâmetro nenhum.
 */
export function enderecoDaVerificacao(email: string, destino: string): string {
  const base = `${CAMINHO_DA_VERIFICACAO}?email=${encodeURIComponent(email)}`;
  const comDestinoNoFim = comDestino(CAMINHO_DA_VERIFICACAO, destino);
  if (comDestinoNoFim === CAMINHO_DA_VERIFICACAO) return base;
  return `${base}&${comDestinoNoFim.split('?')[1]}`;
}

/**
 * A marca de que o e-mail acabou de ser confirmado.
 *
 * Quem clicava no link do e-mail entrava no app e **nada dizia que tinha dado
 * certo**: a Home aparecia como se a pessoa simplesmente tivesse entrado. O
 * parâmetro viaja no `callbackURL` e a chegada o transforma num aviso, antes de
 * limpá-lo do endereço.
 */
export const MARCA_DE_VERIFICADO = 'verificado';

/**
 * Para onde o link do e-mail devolve a pessoa.
 *
 * **É o que faz a intenção de comprar atravessar a confirmação** (F-3): quem
 * chegou ao cadastro vindo de "Comprar o Enac" volta do e-mail direto para a
 * compra, e não para a Home. O servidor só aceita caminho interno - a regra
 * está no `links.ts` da API, e é a mesma do `destinoSeguro` daqui.
 */
export function retornoDoEmail(destino: string): string {
  const separador = destino.includes('?') ? '&' : '?';
  return `${destino}${separador}${MARCA_DE_VERIFICADO}=1`;
}
